import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';

@Component({
  selector: 'app-name-with-icon',
  templateUrl: './name-with-icon.component.html',
  styleUrls: ['./name-with-icon.component.scss']
})
export class NameWithIconComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  agRowData: any;

  constructor() { }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.agRowData = params.node.data;
  }

  addItem(params: ICellRendererParams) {
    if(params.context?.parentComponent) {
      params.context?.parentComponent.addItem(params.data);
    }
  }
}
